module.exports = __webpack_public_path__ + "static/media/post2.649a132a.pdf";